import React from 'react';
import { Navigate } from 'react-router';
import Box from '@amzn/awsui-components-console/box';
import Spinner from '@amzn/awsui-components-console/spinner';
import { useListNamespacesQuery } from 'src/generated/graphql';
import LandingPage from './LandingPage';

/**
 * Entry gate for the "/" route. On load it fetches the user's namespaces; if the
 * user has at least one accessible namespace, it redirects to that namespace's
 * page. Otherwise — no namespaces, or the request failed — it renders the
 * landing page so the user is never left on a blank screen.
 *
 * Only the first namespace is needed to make the decision, so the query asks
 * for a single item.
 */
const LandingEntry: React.FC = () => {
  const { data, loading, error } = useListNamespacesQuery({
    variables: { pageSize: 1 },
  });

  if (loading) {
    return (
      <Box textAlign="center" padding={{ vertical: 'xxxl' }}>
        <Spinner size="large" />
      </Box>
    );
  }

  const firstNamespace =
    !error && data ? data.listNamespaces.namespaces[0] : undefined;

  if (firstNamespace) {
    return <Navigate to={`/${firstNamespace.namespaceId}`} replace />;
  }

  return <LandingPage />;
};

export default LandingEntry;
